/**
 * MDJ Ritual — Persistent Storage
 * Maison de Jarin / Kaarnika Foods
 *
 * assets/mdj-storage.js
 *
 * Lightweight wrapper around localStorage.
 * Stores puzzle progress per product without polluting
 * the global namespace.
 *
 * Public API:
 *   getBestResult()
 *   saveBestResult(result)
 *   isCompleted()
 *   setCompleted(bool)
 *   clear()
 */

(function () {
  'use strict';

  window.MDJRitual = window.MDJRitual || {};

  var PREFIX = 'mdj-ritual:';

  function safeRead(key) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function safeWrite(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function safeRemove(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {}
  }

  function MDJStorage(productHandle) {
    this.productHandle = productHandle || 'default';

    this.bestKey =
      PREFIX + this.productHandle + ':best';

    this.completedKey =
      PREFIX + this.productHandle + ':completed';
  }

  /**
   * Returns:
   * {
   *   moves:Number,
   *   timeMs:Number,
   *   completedAt:Number
   * }
   * or null
   */
  MDJStorage.prototype.getBestResult = function () {
    return safeRead(this.bestKey);
  };

  MDJStorage.prototype.saveBestResult = function (result) {

    if (!result) return;

    var existing = this.getBestResult();

    if (
      !existing ||
      result.moves < existing.moves ||
      (
        result.moves === existing.moves &&
        result.timeMs < existing.timeMs
      )
    ) {

      safeWrite(this.bestKey, {
        moves: result.moves,
        timeMs: result.timeMs,
        completedAt: Date.now()
      });

    }

  };

  MDJStorage.prototype.isCompleted = function () {
    return !!safeRead(this.completedKey);
  };

  MDJStorage.prototype.setCompleted = function (value) {

    if (value) {

      safeWrite(this.completedKey, {
        completed: true,
        at: Date.now()
      });

    } else {

      safeRemove(this.completedKey);

    }

  };

  MDJStorage.prototype.clear = function () {

    safeRemove(this.bestKey);
    safeRemove(this.completedKey);

  };

  window.MDJRitual.Storage = MDJStorage;

})();